<template>
  <div>
    <div class="row ml-0 mr-0" :class="hasBuizenKrat(picLocationsWithProduct, productsWithoutPickLocation)"
         @click="$emit('clicked',idx)">
      <div v-if="order.priority" class="priority col-1">
        <li class="fas fa-exclamation-circle">
        </li>
      </div>
      <div :class="order.priority ? 'col-9' : 'col-10'">
        <p class="cargo"><strong>{{ order.title }}</strong></p>
        <p class="company">{{ getAPICompanyID == 7 ? order.customer : order.receiver.name }}</p>
      </div>
      <div class="col-2 extra-info">
        <div class="deviation-present-container"
             v-if="getDeviationsOfOrder(parseInt(this.order.id), ['PRESENT_ON_FLOOR']).length">
          <transition name="fade" appear>
            <i @click="showDeviations($event)" class="fas fa-exclamation-triangle deviation-present"/>
          </transition>
        </div>
        <div class="loading-check" v-if="isFullypicked">
          <transition name="fade" appear>
            <i class="fas fa-check"/>
          </transition>
        </div>

      </div>
    </div>
    <div class="row ml-0 mr-0">
      <div class="col-12" v-show="idx === inlineDetails || getExpandAll">
        <div class="order-destination" v-if="idx === inlineDetails || getExpandAll">
          <orderDestination :order="order"/>

          <orderProducts :locationType="'loading'" :order=order :key="'pl-id'+idx"
                         v-for="(product,idx) in picLocationsWithProduct"
                         :product="product"/>

          <orderProducts :locationType="'loading'" :order=order :key=idx
                         v-for="(product,idx) in productsWithoutPickLocation"
                         :product="product"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import orderDestination from './OrderDestination';
import orderProducts from './OrderProducts';
import {mapGetters} from 'vuex';
import {deviationPopUp} from "@/mixins/deviationPopUp";

export default {
  name: 'loaded-Cargo-Details',
  props: ['order', 'idx', 'inlineDetails', 'cargo'],
  mixins: [deviationPopUp],
  components: {
    orderDestination,
    orderProducts
  },
  data() {
    return {
      loadingLocations: false,
      orderProducts: [],
      pickLocations: [],
      fullyPickedTest: true
    };
  },
  computed: {
    ...mapGetters(['getAPICompanyID']),
    ...mapGetters('deviations', ['getDeviationsOfOrder']),
    ...mapGetters('orderProducts', ['getProductsFromOrder']),
    ...mapGetters('pickLocations', ['getPickLocationsForOrder']),
    ...mapGetters('root', ['getExpandAll']),
    picLocationsWithProduct() {
      let pickLocations = this.getPickLocationsForOrder(this.order.id);

      let orderProducts = this.getProductsFromOrder(this.order.id);


      pickLocations = _.map(pickLocations, (loc) => {
        loc.locationId = loc.id
        let productInfo = _.find(orderProducts, (prod) => {
          return prod.id.toString() === loc.orderProductId.toString();
        });
        return {...loc, ...productInfo};

      });

      return pickLocations;
    },
    productsWithoutPickLocation() {
      let orderProducts = this.getProductsFromOrder(this.order.id);
      let pickLocations = this.getPickLocationsForOrder(this.order.id);

      // if (!pickLocations.length) {
      //   return orderProducts;
      // }

      const orderProductsWithoutPickLocation = _.filter(orderProducts, orderProduct => {
        return !_.find(pickLocations, pickLocation => {
          return `${pickLocation.orderProductId}` === orderProduct.id;
        })
      });

      return orderProductsWithoutPickLocation;
    },
    isFullypicked() {
      return this.order.fullyPicked || this.allProductsPicked;
    },
    allProductserPicked() {
      if (!this.orderProducts.length) {
        return false;
      }
      return _.every(this.orderProducts, (product) => {
        if (product.location) {
          return product.location.amountPickable <= product.location.amountPicked;
        } else {
          return false;
        }
      });
    }
  },
  methods: {
    showDeviations(event) {
      // Dont open
      event.stopPropagation();
      const deviations = this.getDeviationsOfOrder(parseInt(this.order.id), ['PRESENT_ON_FLOOR']);
      this.showDeviationSwal(deviations);
    },
    getUniquePickLocations(picklocs) {
      return _.uniqBy(picklocs, 'productNumber')
    },
    hasBuizenKrat(piclLocations, products) {
      if (this.getAPICompanyID === 7) {
        const pickLocationIndex = _.findIndex(piclLocations, picklocation => {
          return (picklocation.productName.toLowerCase().indexOf('buizenkrat') > -1 || picklocation.productName.toLowerCase().indexOf('buizen krat') > -1);
        })
        const productLocationIndex = _.findIndex(products, product => {
          return (product.productName.toLowerCase().indexOf('buizenkrat') > -1 || product.productName.toLowerCase().indexOf('buizen krat') > -1);
        })
        if (pickLocationIndex > -1 || productLocationIndex > -1) {
          return 'buizenkrat'
        }
      }
      return '';
    },
  },
  created() {
    // Open deviations of order
    this.$store.dispatch('initDataForPage', [{
      module: 'deviations',
      where: ['orderId', '==', parseInt(this.order.id)]
    }]);
  },
  async beforeDestroy() {
    // Close deviations of order channel
    await this.$store.dispatch('deviations/closeDBChannel', {clearModule: true});
  }
}
;
</script>
<style>
.loading-cargo-info .loading-check i {
  line-height: unset !important;
}

.deviation-container {
  max-height: 40vh;
  overflow-y: scroll;
}

.deviation-table {
  display: grid;
  grid-template-columns: minmax(200px, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 1rem;
  grid-row-gap: 0rem;
  margin-bottom: 2rem;
}

.deviation-label {
  color: #0bcdf8;
}
</style>
<style lang="scss" scoped>


.buizenkrat {
  background-color: #BAF2FF;
}

.priority {
  font-size: 2rem;
  color: #797979;
  align-self: center;
  text-align: center;
}

.deviation-present {
  cursor: pointer;
  margin-right: 0px;
}

.extra-info {
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
  grid-column-gap: 12px;
  align-items: center;
}

.loading-check {
  line-height: unset;
}

.deviation-present-container {
  text-align: right;
}
</style>